import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormControlNames } from '../enums';
import { PasswordErrorService } from '../services/password-error.service';

export interface PasswordFormBundle {
  passwordControl: FormControl;
  confirmPasswordControl: FormControl;
  passwordForm: FormGroup;
}

/**
 * Create password form controls and group with the required validators.
 * This utility only creates and wires the controls; subscriptions that rely on
 * component destroy lifecycle (e.g. takeUntilDestroyed) should remain in the
 * component so they are created in the correct DI/injection context.
 */
export function createPasswordForm(passwordErrorService: PasswordErrorService): PasswordFormBundle {
  const passwordControl = passwordErrorService.createFormControl();
  const confirmPasswordControl = new FormControl('', [Validators.required]);

  const passwordForm = new FormGroup(
    {
      [FormControlNames.PASSWORD]: passwordControl,
      [FormControlNames.CONFIRM_PASSWORD]: confirmPasswordControl,
    },
    {
      validators: passwordErrorService.createPasswordMatchValidator(FormControlNames.PASSWORD, FormControlNames.CONFIRM_PASSWORD),
    },
  );

  return { passwordControl, confirmPasswordControl, passwordForm };
}
